export type DataAction = 'delete' | 'transfer';

export interface DeleteUserForm {
  tasksAction: DataAction;
  tasksTransferUserId: string;
  tasksTransferUserName: string;
  jobsAction: DataAction;
  jobsTransferUserId: string;
  jobsTransferUserName: string;
}

export const EMPTY_DELETE_USER_FORM: DeleteUserForm = {
  tasksAction: 'delete',
  tasksTransferUserId: '',
  tasksTransferUserName: '',
  jobsAction: 'delete',
  jobsTransferUserId: '',
  jobsTransferUserName: '',
};
